/*
 * Bisou Rivage — retours de Max du 17/10 au soir (version ALT). Va avec bisou-alt-plus.css.
 *   3. Accueil au téléphone : les cartes photo prennent l'affiche de 900 px (la vignette de 320 px était floue).
 *   4. Carte du monde : la carte se recale sous la bande des commandes (le globe suit la taille du cadre).
 *   5. 0°C : plus de neige.
 *   6. Panier (20/10) : la ligne du t-shirt se lit comme celle d'un tirage.
 * En « Avant » (classe bvf-off sur <html>), les flocons ajoutés se cachent et la carte se recale.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  function isOff() { return root.classList.contains('bvf-off'); }
  function safe(fn) { try { fn(); } catch (e) { if (window.console) console.warn('[bvf-plus]', e); } }
  var modeFns = [];
  if (window.MutationObserver) {
    var lastOff = isOff();
    new MutationObserver(function () {
      var off = isOff();
      if (off === lastOff) return;
      lastOff = off;
      modeFns.forEach(function (fn) { safe(fn); });
    }).observe(root, { attributes: true, attributeFilter: ['class'] });
  }
  function nudge() { setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 60); }

  /* ---------- 3. Accueil : l'affiche à la taille de la carte ----------
     Au téléphone, le bandeau pose une petite affiche (320 px) sur chaque info ; la carte photo en demande
     une plus grande. On garde le même fichier, servi en 900 px, seulement quand le bandeau approche. */
  safe(function () {
    document.querySelectorAll('[id^="bxs-"] video[data-poster-t]').forEach(function (v) {
      var small = v.getAttribute('data-poster-t');
      var big = /([?&])width=\d+/.test(small) ? small.replace(/([?&])width=\d+/, '$1width=900') : small;
      if (big === small) return;
      v.setAttribute('data-poster-t', big);
      if (v.getAttribute('poster') === small) v.setAttribute('poster', big);
    });
  });

  /* ---------- 4. Carte du monde : recaler le globe sous la bande des commandes ---------- */
  safe(function () {
    if (!document.querySelector('.bcm--compact')) return;
    nudge();
    window.addEventListener('load', nudge);
    modeFns.push(nudge);
  });

  /* ---------- 5. 0°C : plus de neige ---------- */
  safe(function () {
    document.querySelectorAll('.bca--froid .bca__fx').forEach(function (fx) {
      var panel = fx.closest('.bca__panel') || fx.parentNode;
      var rnd = function (a, b) { return a + Math.random() * (b - a); };
      for (var k = 0; k < 44; k++) {
        var big = k % 5 === 0;
        var t = rnd(9, 17);
        var n = document.createElement('i');
        n.setAttribute('data-bvf-p', '');
        if (big) n.className = 'bvfp-big';
        n.style.cssText =
          '--x:' + rnd(0, 100).toFixed(1) + '%;' +
          '--z:' + (big ? rnd(5, 7.5) : rnd(2, 4.4)).toFixed(1) + 'px;' +
          '--o:' + (big ? rnd(0.35, 0.6) : rnd(0.5, 0.95)).toFixed(2) + ';' +
          '--t:' + t.toFixed(1) + 's;' +
          '--d:-' + rnd(0, t).toFixed(1) + 's;' +
          '--w:' + Math.round(rnd(-28, 28)) + 'px';
        fx.appendChild(n);
      }
      function fit() { fx.style.setProperty('--bvfp-fall', Math.round((panel.offsetHeight || 480) + 30) + 'px'); }
      fit();
      window.addEventListener('resize', fit);
      window.addEventListener('load', fit);
    });
  });

  /* ---------- 6. Panier : la ligne du t-shirt comme celle d'un tirage (20/10, retour Max du 19/10) ----------
     Le tiroir épuré (bisou-ventes-fidelite.js § 8) range chaque ligne : sous le titre, l'artiste puis « A3 · Cadre
     noir ». Pour le t-shirt, il n'y avait pas d'artiste, et la ligne des options disait « Précommande · M · Noir » :
     le mode d'expédition passait pour une taille. Ici, après le rangement : une ligne « T-shirt » à la place de
     l'artiste, « M · Noir » seuls, et « Précommande » à part, seulement quand c'en est une. Le compteur du tiroir
     dit « 1 t-shirt » au lieu de « 1 article ». Rien n'est enlevé : le détail du thème reste dans la ligne (dl). */
  safe(function () {
    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }
    function clean(s) { return String(s || '').replace(/\s+/g, ' ').replace(/[\s,:]+$/, '').trim(); }
    function handleOf(item) {
      var a = item.querySelector('.cart-item__name') || item.querySelector('a[href*="/products/"]');
      var m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      return m ? decodeURIComponent(m[1]).toLowerCase() : '';
    }
    function isTee(h) { return h.indexOf('t-shirt') !== -1 || h.indexOf('tshirt') !== -1; }
    function tidy(item) {
      var details = item.querySelector('.cart-item__details');
      var line = details && details.querySelector(':scope > .bvf-line');
      if (!line) return;
      var ship = '';
      var vals = [];
      details.querySelectorAll('dl .product-option').forEach(function (row) {
        var dt = clean(row.querySelector('dt') && row.querySelector('dt').textContent).toLowerCase();
        var dd = clean(row.querySelector('dd') && row.querySelector('dd').textContent);
        if (!dd) return;
        /* 29/10 (langues) : l'option se nomme Expédition, Shipping, Envío ou 発送 selon la langue */
        if (/^(exp|livraison|shipping|env[ií]o|発送)/.test(dt)) ship = dd; else vals.push(dd);
      });
      var key = 'ts|' + ship + '|' + vals.join('|');
      if (line.getAttribute('data-bvf-ts') === key) return;
      line.setAttribute('data-bvf-ts', key);
      if (!line.querySelector('.bvf-line__artist')) {
        var who = el('p', 'bvf-line__artist', { es: 'Camiseta', ja: 'Tシャツ' }[(document.documentElement.lang || '').slice(0, 2)] || 'T-shirt');
        who.setAttribute('data-bvf-p', '');
        line.insertBefore(who, line.firstChild);
      }
      var opts = line.querySelector('.bvf-line__opts');
      if (opts) {
        if (vals.length) opts.textContent = vals.join(' · '); else opts.remove();
      }
      var old = line.querySelector('.bvf-line__ship');
      if (old) old.remove();
      if (ship && !/^(en stock|in stock|在庫あり)$/i.test(ship)) {
        var s = el('p', 'bvf-line__ship', ship);
        s.setAttribute('data-bvf-p', '');
        line.appendChild(s);
      }
    }
    /* Le compteur « 1 article » est écrit et réécrit par le module Ventes & fidélité : on ne le modifie pas
       (les deux scripts se répondraient sans fin). On pose à côté notre propre compteur, « 1 t-shirt », et le
       style cache l'autre tant que le nôtre est là. */
    var TT = {};
    try { TT = JSON.parse(document.getElementById('bvf-config').textContent).cartTidy || {}; } catch (e) { /* sans config : repli français */ }
    function heading() {
      var hd = document.querySelector('#CartDrawer .drawer__heading');
      var span = hd && hd.querySelector('.bvf-cart-n');
      var mine = hd && hd.querySelector('.bvf-cart-ts');
      if (!span) { if (mine) mine.remove(); return; }
      var tees = 0;
      document.querySelectorAll('#CartDrawer .cart-item').forEach(function (item) {
        if (!isTee(handleOf(item))) return;
        var q = item.querySelector('input.quantity__input, input[name="updates[]"]');
        tees += q ? (parseInt(q.value, 10) || 0) : 1;
      });
      /* La part « autres articles » posée par Ventes & fidélité, dans la langue de la page (« 1 article », « 1 item »…) */
      var other = span.getAttribute('data-bvf-other') || '';
      var m = other.match(/\d+/);
      if (!m || !tees || tees !== (parseInt(m[0], 10) || 0) || span.textContent.indexOf(other) < 0) { if (mine) mine.remove(); return; }
      var txt = span.textContent.replace(other, tees === 1 ? (TT.tee1 || '1 t-shirt') : String(TT.teeN || '[n] t-shirts').replace('[n]', tees));
      if (!mine) {
        mine = el('span', 'bvf-cart-ts');
        mine.setAttribute('data-bvf-p', '');
        span.parentNode.insertBefore(mine, span.nextSibling);
      }
      if (mine.textContent !== txt) mine.textContent = txt;
    }
    function run() {
      if (isOff()) return;
      document.querySelectorAll('#CartDrawer .cart-item, cart-items .cart-item').forEach(function (item) {
        if (isTee(handleOf(item))) safe(function () { tidy(item); });
      });
      heading();
    }
    var timer = null;
    function soon() { clearTimeout(timer); timer = setTimeout(run, 80); }
    var hosts = [document.querySelector('cart-drawer'), document.querySelector('cart-items')].filter(Boolean);
    if (!hosts.length) return;
    /* Le style vit ici (pas dans bisou-alt-plus.css) : un seul fichier à relire pour tout ce point */
    if (!document.getElementById('bvf-plus-panier-style')) {
      var st = document.createElement('style');
      st.id = 'bvf-plus-panier-style';
      st.textContent =
        '.bvf-line__ship{font:400 10px/1.4 "Space Mono",var(--font-heading-family,monospace);letter-spacing:.08em;text-transform:uppercase;color:rgb(var(--color-foreground))}' +
        ':root:lang(ja) .bvf-line__ship,:root:lang(ja) .bvf-line__artist[data-bvf-p]{letter-spacing:0}' +
        '.bvf-line__ship::before{content:"";display:inline-block;width:6px;height:6px;margin:0 6px 1px 0;border-radius:50%;background:currentColor;opacity:.55}' +
        '.bvf-cart-ts{font:400 12.5px/1 var(--font-body-family,sans-serif);letter-spacing:.01em;color:rgba(var(--color-foreground),.55);white-space:nowrap}' +
        'html:not(.bvf-off) .drawer__heading:has(> .bvf-cart-ts) > .bvf-cart-n{display:none}';
      document.head.appendChild(st);
    }
    run();
    if (window.MutationObserver) {
      hosts.forEach(function (h) { new MutationObserver(soon).observe(h, { childList: true, subtree: true, characterData: true }); });
    }
    if (typeof window.subscribe === 'function') {
      try { window.subscribe((window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) || 'cart-update', function () { setTimeout(run, 120); }); } catch (e) { /* bus absent */ }
    }
    modeFns.push(soon);
  });
})();
